import Component from "@glimmer/component"
import type { CardStack, CardStackSummary } from "@shared/models/card-stack"
import FindDoc from "cc-frontend/helpers/find-doc"
import { use } from "ember-could-get-used-to-this"

interface Sig {
  Args: {
    cardStackId: string
    useCardStackSummary?: boolean
    useStudentVersion?: boolean
  }
  Blocks: {
    default: [cardStack: CardStack | CardStackSummary | null, cardStackIsFulfilled: boolean]
  }
}

export default class SimpleProviderComponent extends Component<Sig> {
  @use model = new FindDoc(() => [
    this.args.useStudentVersion
      ? "class-website-lesson"
      : this.args.useCardStackSummary
      ? "card-stack-summary"
      : "card-stack",
    this.args.cardStackId,
  ])
}

declare module "@glint/environment-ember-loose/registry" {
  export default interface Registry {
    "Planner::CardStacks::SimpleProvider": typeof SimpleProviderComponent
  }
}
